import React from 'react';
import { CountryCode } from '@dayetopia/types';
import styled from 'styled-components';
import Trustpilot from '@components/shared/Trustpilot';
import { useCountry } from '@hooks/useCountry';

type Props = {};

const ProductHeroTrustPilot: React.FC<Props> = () => {
  const { country } = useCountry();

  if (country === CountryCode.US) {
    return null;
  }

  return (
    <TrustpilotWrap>
      <Trustpilot justifyContent="start" />
    </TrustpilotWrap>
  );
};

export default ProductHeroTrustPilot;

const TrustpilotWrap = styled.div`
  width: 300px;
  margin-left: -40px;
  height: 24px;

  @media (max-width: 1024px) {
    display: none;
  }
`;
